import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { XpressUserService } from 'app/services';
import { XpressDisciplinaryPeriodEnum } from 'app/models';

@Component({
    selector: 'suspend-user',
    templateUrl: './suspend-user.component.html',
    styleUrls: ['./suspend-user.component.scss'],
    providers: [MessageService]
})
export class SuspendUserComponent implements OnInit {
    @Input() public userId: number | null = null;
    @Input() public userName: string | null = null;

    public displayModalSuspend: boolean = false;
    @Input()
    set _displayModalSuspend(value: boolean) {
        this.displayModalSuspend = value;
        if (value) {
            this.resetForm();
        }
    }

    @Input() public activeResumeButton: boolean = false;
    @Input() _isLiftSuspensionAction: boolean = false;

    @Output() changedDisplayModalSuspendEmit = new EventEmitter<boolean>();
    @Output() suspendSuccessEmit = new EventEmitter<void>();
    @Output() liftSuspensionSuccessEmit = new EventEmitter<void>();

    reasonOptions = [
        { label: 'Abuse / Harassment', value: 'Abuse / Harassment' },
        { label: 'Fraud / Chargeback', value: 'Fraud / Chargeback' },
        { label: 'Policy Violation', value: 'Policy Violation' },
        { label: 'Other', value: 'Other' }
    ];

    durationOptions = [
        { label: '24 Hours', value: XpressDisciplinaryPeriodEnum.OneDay },
        { label: '3 Days', value: XpressDisciplinaryPeriodEnum.ThreeDays },
        { label: '7 Days', value: XpressDisciplinaryPeriodEnum.SevenDays }
    ];

    liftReasonOptions = [
        { label: 'Review Completed', value: 'Review Completed' },
        { label: 'Appeal Approved', value: 'Appeal Approved' },
        { label: 'Ops Override', value: 'Ops Override' },
        { label: 'Other', value: 'Other' }
    ];

    selectedReason: string | null = null;
    selectedDuration: XpressDisciplinaryPeriodEnum | null = null;
    additionalDetails: string = '';

    selectedLiftReason: string | null = null;
    liftNotes: string = '';

    constructor(
        private messageService: MessageService,
        private xpressUserService: XpressUserService
    ) { }

    ngOnInit(): void { }

    isFormValid(): boolean {
        return !!this.selectedReason && this.selectedDuration !== null;
    }

    isLiftFormValid(): boolean {
        return !!this.selectedLiftReason;
    }

    resetForm(): void {
        this.selectedReason = null;
        this.selectedDuration = null;
        this.additionalDetails = '';
        this.selectedLiftReason = null;
        this.liftNotes = '';
    }

    public saveSuspend() {
        if (!this.isFormValid()) { return; }

        const sanitizedDetails = this.additionalDetails?.trim().replace(/\|/g, '') || '';
        const reason = sanitizedDetails
            ? `${this.selectedReason}|${sanitizedDetails}`
            : this.selectedReason;

        const dto = {
            UserId: this.userId,
            SuspendedPeriod: this.selectedDuration,
            SuspendedReason: reason
        };

        this.xpressUserService.saveSuspendByUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.displayModalSuspend = false;
                this.changedDisplayModalSuspendEmit.emit(false);
                this.suspendSuccessEmit.emit();
            });
    }

    public liftSuspension() {
        if (!this.isLiftFormValid()) { return; }

        const reason = this.liftNotes?.trim()
            ? `${this.selectedLiftReason} - ${this.liftNotes.trim()}`
            : this.selectedLiftReason;

        const dto = {
            UserId: this.userId,
            Reason: reason
        };

        this.xpressUserService.liftSuspensionUser(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.displayModalSuspend = false;
                this.changedDisplayModalSuspendEmit.emit(false);
                this.liftSuspensionSuccessEmit.emit();
            });
    }

    cancel() {
        this.displayModalSuspend = false;
        this.changedDisplayModalSuspendEmit.emit(false);
    }
}
